export const monCompteCommanderANouveauProps = () => ({
  commande: {
    type: Object,
    required: true
  }
})

export const monCompteCommanderANouveauEmits = () => ([
  "addAllToCart"
])

export const useMonCompteCommanderANouveau = (context) => {
  const addAllToCart = () => {
    context.emit("addAllToCart");
  }
  return { addAllToCart }
}
